'use client'

import Link from 'next/link'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
      }}
    >
      <h1>Namespace Error</h1>
      <p>{error.message}</p>
      <Button onClick={() => reset()}>Retry</Button>

      <Link href="/">Go back to Home</Link>
    </Stack>
  )
}
